import React, {useMemo} from 'react';
import RCSelect from 'react-select';

export default function Select(
  {
    style,
    options,
    keyValue,
    value,
    loading,
    onChange = () => null,
    containerStyle = {},
    controlStyle = {},
    inputStyle = {},
    indicatorSeparator = {},
    placeholder = '请选择',
  }) {
  
  const customStyles = {
    container: (provided) => ({
      ...provided,
      ...containerStyle
    }),
    control: (provided, state) => ({
      ...provided,
      border: '1px solid #dfdfdf',
      boxSizing: 'border-box',
      textAlign: 'left',
      borderRadius: 3,
      marginBottom: 20,
      fontSize: 14,
      ...controlStyle,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: '0 15px',
    }),
    input: (provided, state) => ({
      ...provided,
      margin: 0,
      padding: '15px 0',
      textAlign: 'left',
      ...inputStyle
    }),
    option: (provided) => ({
      ...provided,
      textAlign: 'left',
      fontSize: 14,
    }),
    loadingIndicator: (provided, isLoading) => ({
      ...provided,
      // backgroundColor:isLoading ? 'red' : 'green'
      padding: '0 5px',
      opacity: 0.2,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: '0'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    })
  };
  
  const __options = useMemo(() => {
    if (!options) return [];
    if (!keyValue) return options;
    
    return options.map(option => ({
      label: option[keyValue.label],
      value: option[keyValue.value],
      ...option
    }));
  }, [keyValue, options]);
  
  return (
    <RCSelect options={__options}
              onChange={onChange}
              isLoading={loading}
              value={__options.find(obj => obj.value === value) || undefined}
              placeholder={placeholder}
              styles={customStyles}/>
  );
}
